<template>
  <v-dialog v-model="show" max-width="400px">
    <v-card>
      <v-card-title style="justify-content: center">{{ modalTitle }}</v-card-title>
      <v-card-text v-if="introductionSentence" class="pb-0">{{ introductionSentence }}</v-card-text>
      <v-text-field class="ml-2 mr-2" :placeholder="modalTitle" v-model="text"></v-text-field>
      <v-card-actions class="pa-0">
        <v-btn color="primary" tile :disabled="this.text.trim() == ''" @click="validate()" style="width: 50%">
          {{ $t('subOrder.validate') }}
        </v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'SimpleTextInputDialog',
    data() {
      return {
        text: '',
      }
    },
    props: {
      title: {
        type: String,
        default: undefined,
      },
      introductionSentence: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      closeOnValidate: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      modalTitle: function () {
        if (!this.title) {
          return this.$t('components.modalMultipleChoices.defaultTitle')
        } else return this.title
      },
    },
    methods: {
      validate: function () {
        if (this.text.trim() != '') {
          this.$emit('validate', this.text.trim())
          this.text = ''
          if (this.closeOnValidate) {
            this.show = false
          }
        }
      },
      close: function () {
        this.text = ''
        this.$emit('close')
        this.show = false
      },
    },
  }
</script>
<style scoped>
  .w-45 {
    width: 45%;
  }
</style>
